import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import {
  ISIVReportAdverseEventReporting,
  ISIVReportMonitoring,
  ISIVReportRequirementsforEcrfcompletion,
  ISIVReportSourceDocumentation
} from 'src/types/SIVReport';
import AdverseEventReporting from './AdverseEventReporting';
import Monitoring from './Monitoring';
import RequirementsforEcrfcompletion from './RequirementsforEcrfcompletion';
import './SivReport.scss';
import SourceDocumentation from './SourceDocumentation';
import {
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  ISIVReportStep2Accordions,
  MandatoryData
} from './useSivReport';

export interface ISIVReportPageStep2 {
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  expandedState: ISIVReportStep2Accordions;
  toggle: (key: keyof ISIVReportStep2Accordions, expanded: boolean) => void;
  adverseEventReportingData: ISIVReportAdverseEventReporting;
  updateAdverseEventReporting: (data: ISIVReportAdverseEventReporting) => void;
  updateSourceDocumentation: (data: ISIVReportSourceDocumentation) => void;
  sourceDocumentationData: ISIVReportSourceDocumentation;
  updateMonitoring: (data: ISIVReportMonitoring) => void;
  monitoringData: ISIVReportMonitoring;
  requirementsforEcrfCompletionData: ISIVReportRequirementsforEcrfcompletion;
  updateRequirementsforEcrfCompletion: (data: ISIVReportRequirementsforEcrfcompletion) => void;
  isUpdate: boolean;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  Step2: ISIVReportStep2Accordions;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: ISIVReportMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const SIVReportPage: React.FunctionComponent<ISIVReportPageStep2> = ({
  getSivReportData,
  saveDisable,
  expandedState,
  toggle,
  adverseEventReportingData,
  updateAdverseEventReporting,
  sourceDocumentationData,
  updateSourceDocumentation,
  requirementsforEcrfCompletionData,
  updateRequirementsforEcrfCompletion,
  monitoringData,
  updateMonitoring,
  isUpdate,
  setIsChange,
  Step2,
  updateSIVReportMandatoryData,
  mandatory,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.adverseEventReporting}
        onChange={(_, expanded) => {
          toggle('adverseEventReporting', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Adverse Event Reporting </Typography>
        </AccordionSummary>
        <AdverseEventReporting
          adverseEventReportingData={adverseEventReportingData}
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          isChange={Step2.adverseEventReporting}
          updateAdverseEventReporting={updateAdverseEventReporting}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.adverseEventReporting}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.requirementsforEcrfcompletion}
        onChange={(e, expanded) => {
          toggle('requirementsforEcrfcompletion', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Requirements for eCRF completion </Typography>
        </AccordionSummary>
        <RequirementsforEcrfcompletion
          getSivReportData={getSivReportData}
          isChange={Step2.requirementsforEcrfcompletion}
          saveDisable={saveDisable}
          requirementsforEcrfCompletionData={requirementsforEcrfCompletionData}
          updateRequirementsforEcrfCompletion={updateRequirementsforEcrfCompletion}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.requirementsforEcrfcompletion}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.sourceDocumentation}
        onChange={(e, expanded) => {
          toggle('sourceDocumentation', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Source Documentation </Typography>
        </AccordionSummary>
        <SourceDocumentation
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          sourceDocumentationData={sourceDocumentationData}
          updateSourceDocumentation={updateSourceDocumentation}
          isUpdate={isUpdate}
          isChange={Step2.sourceDocumentation}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.sourceDocumentation}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.monitoring}
        onChange={(e, expanded) => {
          toggle('monitoring', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4bh-content" id="panel4bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Monitoring </Typography>
        </AccordionSummary>
        <Monitoring
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          monitoringData={monitoringData}
          updateMonitoring={updateMonitoring}
          isUpdate={isUpdate}
          isChange={Step2.monitoring}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.monitoring}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>
    </div>
  );
};

export default SIVReportPage;
